import styled, { keyframes } from "styled-components";
import PageHeader from "../../components/PageHeader";
import {
    Heading,
    Flex,
    Image,
    Text,
    Link,
    Button,
    HelpIcon,
    Card,
    CardBody,
    Skeleton,
} from "@pancakeswap/uikit";
import Balance from "../../components/Balance";
import Page from "../../components/Layout/Page";
import PoolTabButtons from "./components/PoolTabButtons";
import { useCallback, useEffect, useRef, useState } from "react";
import Select from "../../components/Select/Select";
import SearchInput from "../../components/SearchInput";
import BaseCell from "./components/PoolsTable/Cells/BaseCell";
import PoolsTable from "../Pools/components/PoolsTable/PoolsTable";
import PoolCard from "./components/PoolCard";
import {
    getLockUpAddress,
    getMulticallAddress,
    getTokenAddress,
} from "utils/addressHelpers";
import { multicallv2 } from "utils/multicall";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import TokenABI from "ABI/TokenABI.json";
import MulticallABI from "ABI/MulticallABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import ERC20ABI from "ABI/ERC20ABI.json";
import addresses from "constants/contract";
import { PoolData } from "config/constants/types";
import { BigNumber, ethers } from "ethers";
import { useWeb3React } from "@web3-react/core";
import { divide } from "lodash";
import { Box, Container, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getIdx, setIdx } from "store/IndexSlice";
import RoiCalculatorModal from "./components/Modal/RoiCalculatorModal";
import dvx_header from "../../assets/images/dvx_header.png";
import bnb_header from "../../assets/images/bnb_header.png";
import busd_img from "../../assets/images/busd_img.png";
import { getContract } from "utils/contractHelpers";

const PoolControls = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
  position: relative;
  // justify-content:start;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 32px;

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 16px 32px;
    margin-bottom: 0;
  }
`;
const Poolcards = styled(Box)`
  /* display:flex;
    flex-direction: column; */
  margin-left: 6rem;
  margin-right: 6rem;
  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
    flex-direction: row;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex-direction: row;
  }
`;
const LabelWrapper = styled.div`
  > ${Text} {
    font-size: 12px;
  }
`;

const StyledTableBorder = styled.div`
  border-radius: ${({ theme }) => theme.radii.card};
  background-color: ${({ theme }) => theme.colors.cardBorder};
  padding: 1px 1px 3px 1px;
  background-size: 400% 400%;
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    padding: 0;
  }
`;

const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`;

// const Container = styled.div`
//   margin-right: 16px;
//   display: flex;
//   justify-content: flex-end;

//   ${({ theme }) => theme.mediaQueries.sm} {
//     flex: 1;
//   }
// `;

const ConnectButton = styled.a`
  -webkit-box-align: center;
  align-items: center;
  border: 0px;
  border-radius: 8px;
  box-shadow: rgb(14 14 44 / 40%) 0px -1px 0px 0px inset;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 15px;
  -webkit-box-pack: center;
  justify-content: center;
  letter-spacing: 0.03em;
  line-height: 1;
  opacity: 1;
  outline: 0px;
  transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
  height: 40px;
  padding: 0px 20px;
  background-color: #00fed9;
  color: black;
  font-weight: bold;
  &:hover {
    background-color: #00fed9;
    opacity: 0.6;
  }
`;

const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;
const StyledCard = styled(Card)`
  width: 100%;
  flex: 1;
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 240px;
  }
`;

const BodyWrapper = styled(Box)`
  position: relative;
  display: flex;
`;

const ControlStretch = styled(Flex)`
  > div {
    flex: 1;
  }
`;

const StyledCell = styled(BaseCell)`
  flex: 5;
  flex-direction: row;
  padding-left: 12px;
  ${({ theme }) => theme.mediaQueries.sm} {
    /* flex: 1 0 150px; */
    padding-left: 32px;
  }
`;

const Loading = styled.div`
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid #ddd;
  border-bottom: 8px solid #ddd;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const StyledRow = styled.div`
  background-color: transparent;
  display: flex;
  cursor: pointer;
`;
const PoolsData = styled.div`
  margin-right: 2rem;
  margin-left: 2rem;
  max-width: 1150px;
  width: 100%;
`;

export const dvxkeyframe = keyframes`
    0%   {left:0px; top:0px;}
    50%  {left:10px; top:10px;}
    100% {left:0px; top:0px;}
`;
export const bnbkeyframe = keyframes`
    0%   {left:0px; top:0px;}
    50%  {left:12px; top:12px;}
    100% {left:0px; top:0px;}
`;
export const busdkeyframe = keyframes`
    0%   {left:0px; top:0px;}
    50%  {bottom:20px; top:20px; right:20px; }
    100% {left:0px; top:0px;}
`;

export const DVXImg = styled.div`
  position: relative;
  z-index: 2;
  animation: 3s ease-in-out 0.66s infinite normal none running ${dvxkeyframe};
`;
export const BNBImg = styled.div`
  position: relative;
  animation: 3s ease-in-out 0.66s infinite normal none running ${bnbkeyframe};
`;
export const BusdImg = styled.div`
  position: relative;
  animation: 3s ease-in-out 0.66s infinite normal none running ${busdkeyframe};
`;

let pools: PoolData[] = [
    {
        contractType: "lockup",
        stackType: 0,
        duration: 0,
        user: {
            tokenbalance: "0",
            userstack: "-1",
            pendingreward: "0",
            stakeendin: "0",
        },
    },
    {
        contractType: "lockup",
        stackType: 1,
        duration: 0,
        user: {
            tokenbalance: "0",
            userstack: "-1",
            pendingreward: "0",
            stakeendin: "0",
        },
    },
    {
        contractType: "lockup",
        stackType: 2,
        duration: 0,
        user: {
            tokenbalance: "0",
            userstack: "-1",
            pendingreward: "0",
            stakeendin: "0",
        },
    },
    {
        contractType: "lockup",
        stackType: 3,
        duration: 0,
        user: {
            tokenbalance: "0",
            userstack: "-1",
            pendingreward: "0",
            stakeendin: "0",
        },
    },
];

const userDataLoaded = false;

const account = "";

const roundOff = (figure, decimals) => {
    if (!decimals) decimals = 2;
    var d = Math.pow(10, decimals);
    let val = (parseInt((figure * d).toString()) / d).toFixed(decimals);
    return parseFloat(val);
};
const calAPY = (lockupRate, totalStaked, decimal) => {
    // console.log(lockupRate.toString() + " " + totalStaked);
    if (totalStaked == 0) return 0;
    const rewardPerBlock = lockupRate / totalStaked;
    let aprvalue = (rewardPerBlock * 28555 * 365) / Math.pow(10, decimal - 2);
    aprvalue = roundOff(aprvalue, 4);
    return aprvalue;
    // const blockPerYear = BigNumber.from(`${2878 * 365}`);
    // return rewardPerBlock.mul(blockPerYear)
};

interface IPool { 
    price: number
}
const Pools: React.FC<IPool> = ({price}) => {

    // useEffect(()=>{
    //     document.title='Pools | DRIVENswap V2.0'
    // });
    // const [expanded, setExpanded] = useState(false);

    const idx = useSelector((state: any) => state.Index.idx);
    const pidx = useSelector((state: any) => state.Index.processidx);

    const { error, connector, activate, deactivate, library, active, account } =
        useWeb3React();
    const [allpooldata, setPoolData] = useState([]);
    const [filteredPool, setfilteredPool] = useState([]);
    const [updateUser, setUpdateUser] = useState(false);

    const [isChecked, setIsChecked] = useState(false);
    const [isLive, setIsLive] = useState(true);
    const [handleSortOptionChange, setHandleSortOptionChange] = useState(0);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setIdx(-1));
    };

    let tokenContractCall = [];
    let lockUpContractCall = [];
    let multiContractCall = [];
    const tokenAddress = getTokenAddress();
    const lockupAddress = getLockUpAddress();
    const multicallAddress = getMulticallAddress();
    tokenContractCall.push(
        ...["name", "symbol", "decimals"].map((method) => ({
            address: tokenAddress,
            name: method,
        }))
    );
    multiContractCall.push(
        ...["getBlockNumber"].map((method) => ({
            address: multicallAddress,
            name: method,
        }))
    );
    lockUpContractCall.push(
        ...[
            "bonusEndBlock",
            "earnedToken",
            "stakingToken",
            "PRECISION_FACTOR",
            "uniRouterAddress",
        ].map((method) => ({
            address: lockupAddress,
            name: method,
        }))
    );

    pools.forEach((pool) => {
        if (pool.contractType == "lockup") {
            lockUpContractCall.push(
                ...["lockups"].map((method) => ({
                    address: lockupAddress,
                    name: method,
                    params: [pool.stackType],
                }))
            );
            // const lockupAddress = getLockUpAddress();
        }
    });
    const lock = useRef(false);

    const fetchInfo = async () => {
        if (lock.current) return;
        lock.current = true;
        try {
            const tokenCallContractData = await multicallv2(
                TokenABI,
                tokenContractCall
            );
            const lockUpContractData = await multicallv2(
                DrivenLockupABI,
                lockUpContractCall
            );
            const multiCallContractData = await multicallv2(
                MulticallABI,
                multiContractCall
            );
            // console.log(multiCallContractData.toString());

            let routeAddress = lockUpContractData[4][0];
            const routerContract = getContract(UniRouterABI, routeAddress);
            const usdContract = getContract(ERC20ABI, addresses.TokenToUsd[3]);
            let usdPrice = await routerContract.getAmountsOut(
                ethers.utils.parseEther("1"),
                addresses.TokenToUsd
            );
            const usdDecimal = await usdContract.decimals();
            usdPrice = parseFloat(
                ethers.utils.formatUnits(usdPrice[3].toString(), usdDecimal)
            );

            pools.forEach((pool) => {
                if (pool.contractType == "lockup") {
                    // console.log(lockUpContractData);
                    pool.name = tokenCallContractData[0][0];
                    pool.symbol = tokenCallContractData[1][0];
                    pool.decimals = tokenCallContractData[2][0];
                    pool.bonusEndBlock = lockUpContractData[0][0].toString();
                    pool.earnedToken = lockUpContractData[1][0];
                    pool.stakingToken = lockUpContractData[2][0];
                    pool.pf = lockUpContractData[3][0];
                    pool.tokenUsdprice = usdPrice;
                    pool.duration = lockUpContractData[pool.stackType + 5].duration;
                    pool.rate = lockUpContractData[pool.stackType + 5].rate;
                    pool.apy = calAPY(
                        parseFloat(pool.rate.toString()),
                        parseFloat(
                            ethers.utils.formatUnits(
                                lockUpContractData[pool.stackType + 5].totalStaked,
                                pool.decimals
                            )
                        ),
                        tokenCallContractData[2][0]
                    );
                    pool.depositFee = (
                        lockUpContractData[pool.stackType + 5].depositFee / 100
                    ).toString();
                    pool.totalStaked = ethers.utils.formatUnits(
                        lockUpContractData[pool.stackType + 5].totalStaked,
                        pool.decimals
                    );
                    pool.enableCompound =
                        lockUpContractData[pool.stackType + 5].enableCompound.toString();
                    // pool.apyrate = ethers.utils.formatEther(
                    //     lockUpContractData[pool.stackType + 3].totalStaked
                    // );
                    pool.withdrawFee = (
                        lockUpContractData[pool.stackType + 5].withdrawFee / 100
                    ).toString();
                    pool.emergencyWithdrawFee = (
                        lockUpContractData[pool.stackType + 5].emergencyWithdrawFee / 10
                    ).toString();
                    pool.bounsEnd = lockUpContractData[0][0].toString();
                    pool.endsin = (lockUpContractData[0][0]
                        .sub(multiCallContractData[0][0]))
                        .toString();
                }
            });

            setPoolData(pools);
            // setfilteredPool(pools);
        } catch (error) {

        }
        lock.current = false;
    };
    useEffect(() => {
        setInterval(fetchInfo, 4000);
    }, []);
    useEffect(() => {
        fetchInfo();
    }, [pidx]);


    const dateFormator = (epoch) => {
        let date = new Date(parseFloat(epoch.toString()) * 1000);
        // console.log((date.getMinutes().toString()).padStart(2, '0'))
        let month = date.toDateString().substring(4, 7);
        let day = date.getDate();
        let year = date.getFullYear();
        let h = date.getHours();
        let m = date.getMinutes();
        let minutes = m <= 9 ? "0" + m : m;
        return `${month} ${day}, ${year}, ${h}:${minutes}`;
        // return date.toDateString()
    };

    const fetchUserDetails = async () => {
        const userPool = [...allpooldata];
        if (account && allpooldata.length > 0) {
            let lockUpContractCall = [];
            let tokenContractCall = [];
            // const lockupAddress = getLockUpAddress();
            // const tokenAddress = getTokenAddress();

            tokenContractCall.push(
                ...["balanceOf"].map((method) => ({
                    address: tokenAddress,
                    name: method,
                    params: [account],
                }))
            );
            tokenContractCall.push(
                ...["allowance"].map((method) => ({
                    address: tokenAddress,
                    name: method,
                    params: [account, lockupAddress],
                }))
            );

            // userPool.forEach((pool) => {
            for (let pool of userPool) {
                if (pool.contractType == "lockup") {
                    lockUpContractCall.push(
                        ...["userInfo"].map((method) => ({
                            address: lockupAddress,
                            name: method,
                            params: [pool.stackType, account],
                        }))
                    );
                    lockUpContractCall.push(
                        ...["pendingReward", "getActiveStake"].map((method) => ({
                            address: lockupAddress,
                            name: method,
                            params: [account, pool.stackType],
                        }))
                    );
                }
            }
            const fetchUserInfo = async () => {
                const tokenCallContractData = await multicallv2(
                    TokenABI,
                    tokenContractCall
                );
                const lockUpContractData = await multicallv2(
                    DrivenLockupABI,
                    lockUpContractCall
                );
                // userPool.forEach(async (pool) => {
                for (let pool of userPool) {
                    if (pool.contractType == "lockup") {
                        pool.user.tokenbalance = tokenCallContractData[0][0].toString();
                        pool.user.allowance = tokenCallContractData[1][0].toString();
                        pool.user.userstack =
                            lockUpContractData[pool.stackType * 3][0].toString();
                        pool.user.pendingreward = ethers.utils
                            .formatUnits(
                                BigNumber.from(lockUpContractData[pool.stackType * 3 + 1][0]),
                                18
                            )
                            .toString();
                        pool.user.stakeendinEpoch = parseInt(lockUpContractData[pool.stackType * 3 + 2][0][3].toString());
                        pool.user.stakeendin = dateFormator(
                            lockUpContractData[pool.stackType * 3 + 2][0][3]
                        );
                    }
                }
                setPoolData(userPool);
                // setfilteredPool(userPool);
            };
            await fetchUserInfo();
        }
        // else {
        //     for (let pool of userPool) {
        //         pool.user.tokenbalance = "0";
        //         pool.user.userstack = "0";
        //         pool.user.pendingreward = "0";
        //         pool.user.stakeendin = "";
        //     }
        //     setPoolData(userPool);
        //     setfilteredPool(userPool);
        // }
    }

    useEffect(() => {
        fetchUserDetails();

    }, [account, allpooldata]);

    const [searchvalue, setSearchValue] = useState("");

    useEffect(() => {
        stackChange(isChecked, isLive, handleSortOptionChange, searchvalue)
    }, [isChecked, isLive, handleSortOptionChange, searchvalue, allpooldata])
    // const [stakedOnly, setStakedOnly] = useUserPoolStakedOnly()
    const stackChange = (
        isStackedChange,
        isLive,
        handleSortOptionChange,
        searchvalue
    ) => {
        let temp = allpooldata.filter((ele) => {
            return (
                ((isStackedChange && parseFloat(ele.user.userstack) > 0) ||
                    !isStackedChange) &&
                ((isLive && parseInt(ele.endsin) == 0) || isLive) &&
                (ele.name.toLowerCase().includes(searchvalue.toLowerCase()) ||
                    ele.symbol.toLowerCase().includes(searchvalue.toLowerCase()))
            );
        });
        if (handleSortOptionChange === "totalStaked") {
            temp = temp.sort(
                (ele1, ele2) => parseInt(ele2.totalStaked) - parseInt(ele1.totalStaked)
            );
        } else if (handleSortOptionChange === "earned") {
            temp = temp.sort(
                (ele1, ele2) =>
                    parseFloat(ele2.user.pendingreward) -
                    parseFloat(ele1.user.pendingreward)
            );
        } else if (handleSortOptionChange === "apy") {
            temp = temp.sort((ele1, ele2) => parseInt(ele2.apy) - parseInt(ele1.apy));
        } else if (handleSortOptionChange === "latest") {
            temp = temp.sort(
                (ele1, ele2) => parseInt(ele2.endsin) - parseInt(ele1.endsin)
            );
        }
        setfilteredPool(temp);
    };
    const [istoggleview, setIsToggleview] = useState(true);
    // const hasStakeInFinishedPools = stakedOnlyFinishedPools.length > 0

    // const toggleExpanded = () => {
    //   setExpanded((prev) => !prev);
    // };
    // const handleSortOptionChange = useCallback((option: OptionProps) => setSortOption(option.value), [])
    // const tableLayout = <PoolsTable pools={chosenPools} account={account} userDataLoaded={userDataLoaded} />

    return (
        <>
            <Box sx={{ background: "#000B22" }}>
                <Container>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: {
                                xs: "center",
                                sm: "center",
                                md: "start",
                                lg: "start",
                            },
                            flexDirection: {
                                xs: "column",
                                sm: "column",
                                md: "row",
                                lg: "row",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                pt: 4,
                                pb: 5,
                                color: "white",
                                display: "flex",
                                flexDirection: "column",
                                mr: { xs: 0, sm: 0, md: 8, lg: 8 },
                                flex: "1 1 0%",
                                minWidth: { xs: "100%", sm: "100%", md: "370px", lg: "370px" },
                                maxWidth: { xs: "100%", sm: "100%", md: "450px", lg: "450px" },
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: {
                                        xs: "1.25rem",
                                        sm: "1.25rem",
                                        md: "2.75rem",
                                        lg: "2.75rem",
                                    },
                                    lineHeight: 2.5,
                                    fontWeight: "bold",
                                    display: { xs: "flex", sm: "flex", md: "block", lg: "block" },
                                    justifyContent: {
                                        xs: "center",
                                        sm: "center",
                                        md: "start",
                                        lg: "start",
                                    },
                                }}
                            >
                                STAKING POOLS
                            </Typography>
                            <Typography
                                sx={{
                                    color: "rgb(177, 179, 203)",
                                    textAlign: {
                                        xs: "center",
                                        sm: "center",
                                        md: "start",
                                        lg: "start",
                                    },
                                }}
                            >
                                Stake your tokens in a range of projects to earn passive income.
                            </Typography>
                            {/* <Box>
                                    High APR, low risk.
                                </Box> */}
                            <Box
                                sx={{
                                    mt: 2,
                                    display: { xs: "flex", sm: "flex", md: "block", lg: "block" },
                                    justifyContent: {
                                        xs: "center",
                                        sm: "center",
                                        md: "start",
                                        lg: "start",
                                    },
                                }}
                            >
                                <ConnectButton
                                    target="_blank"
                                    href="https://pancakeswap.finance/swap?outputCurrency=0x6db3972c6a5535708e7A4F7Ad52F24d178D9A93e"
                                >
                                    Get DRIVENx
                                </ConnectButton>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                // flex: "1 1 0%",
                                display: "flex",
                                justifyContent: "center",
                                height: "100%",
                                mt: { xs: 0, sm: 0, md: 4, lg: 4, xl: 4 },
                                // ml: { xl: "0%", lg: "0%", md: "0px", sm: "30%", xs: "20%" },
                            }}
                        >
                            <Box sx={{ position: "relative", maxHeight: "512px" }}>
                                {/* <Box sx={{ left:'50%' }}> */}
                                <DVXImg>
                                    <picture>
                                        <source type="image/webp" srcSet={dvx_header} />
                                        <source type="image/png" srcSet={dvx_header} />
                                        <img
                                            src={dvx_header}
                                            style={{
                                                maxWidth: "200px",
                                                width: "100%",
                                                height: "100%",
                                                maxHeight: "200px",
                                            }}
                                        />
                                    </picture>
                                </DVXImg>
                                <Box
                                    sx={{
                                        height: "100%",
                                        position: "absolute",
                                        zIndex: 1,
                                        top: "0px",
                                        left: "0px",
                                    }}
                                >
                                    <BNBImg>
                                        <picture>
                                            <source type="image/webp" srcSet={bnb_header} />
                                            <source type="image/png" srcSet={bnb_header} />
                                            <img
                                                src={bnb_header}
                                                style={{
                                                    maxWidth: "200px",
                                                    width: "100%",
                                                    height: "100%",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                        </picture>
                                    </BNBImg>
                                </Box>
                                <Box
                                    sx={{
                                        height: "100%",
                                        position: "absolute",
                                        zIndex: 0,
                                        top: "0px",
                                        left: "0px",
                                    }}
                                >
                                    <BusdImg>
                                        <picture>
                                            <source type="image/webp" srcSet={busd_img} />
                                            <source type="image/png" srcSet={busd_img} />
                                            <img
                                                src={busd_img}
                                                style={{
                                                    maxWidth: "200px",
                                                    width: "100%",
                                                    height: "100%",
                                                    maxHeight: "200px",
                                                }}
                                            />
                                        </picture>
                                    </BusdImg>
                                    {/* </Box> */}
                                </Box>
                            </Box>

                            {/* <img src={dvx_header} />
                            <img src={bnb_header} /> */}
                        </Box>
                    </Box>
                </Container>
            </Box>


            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <PoolsData>
                    <PoolControls>
                        <PoolTabButtons
                            stackChange={stackChange}
                            setSearchValue={setSearchValue}
                            searchvalue={searchvalue}
                            isChecked={isChecked}
                            setIsChecked={setIsChecked}
                            isLive={isLive}
                            setIsLive={setIsLive}
                            handleSortOptionChange={handleSortOptionChange}
                            setHandleSortOptionChange={setHandleSortOptionChange}
                            setIsToggleview={setIsToggleview}
                        // stakedOnly={stakedOnly}
                        // hasStakeInFinishedPools={hasStakeInFinishedPools}
                        // viewMode={viewMode}
                        // setViewMode={setViewMode}
                        />
                    </PoolControls>
                    {istoggleview ? (
                        <PoolsTable
                            price={price}
                            pools={filteredPool}
                            account={account}
                            userDataLoaded={userDataLoaded}
                        />
                    ) : (
                        <Grid container spacing={0}>
                            {filteredPool.length !== 0 ? (
                                filteredPool.map((pool, index) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={4}
                                        sx={{ display: "flex", justifyContent: "center" }}
                                    >
                                        <PoolCard pool={pool} price={price} index={index} account={account} />
                                    </Grid>
                                ))
                            ) : (
                               ''
                            )}
                        </Grid>
                    )}
                </PoolsData>
                {idx != -1 && (
                    <RoiCalculatorModal
                        open={idx != -1}
                        onClose={handleClose}
                        pool={filteredPool[idx]}
                    ></RoiCalculatorModal>
                )}
            </Box>
        </>
    );
};

export default Pools;
